import { Box, Button, Typography } from "@mui/material";
import { useEffect } from "react";
import { FiPlus } from "react-icons/fi";
import Table from "../../components/Table";
import {
  deleteTestimonials,
  viewTestimonials,
} from "../../../states/actions/testimonialsAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Avatar } from "@mui/material";
import Layout from "../layout/Layout";
import Loading from "../loading/Loading";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const ViewTestimonial = () => {
  // dispatch
  const dispatch = useDispatch();

  // hooks
  const testimonials = useSelector((state) => state.testimonials);
  // use effect
  useEffect(() => {
    dispatch(viewTestimonials());
  }, []);

  const navigate = useNavigate();

  const handleUpdateTestimonial = (data) => {
    navigate("/update-testimonials/" + data.id);
  };

  function handleRemoveTestimonial(data) {
    if (
      window.confirm(
        "Data deleted permantly. Are you sure to delete completely!"
      )
    ) {
      dispatch(deleteTestimonials(data.id));
    }
    setTimeout(function () {
      dispatch(viewTestimonials());
    }, 1000);
  }
  const testimonialsColumns = [
    {
      accessorKey: "full_Name", //access nested data with dot notation
      header: "Full Name",
    },

    {
      accessorKey: "clients_say", //access nested data with dot notation
      header: "Clients Say",
    },
    {
      accessorKey: "photo", //access nested data with dot notation
      header: "Images",
      size: 100,
      Cell: ({ cell }) => (
        <div>
          <Avatar
            src={`${BaseUrl}${cell.getValue()}`.replace(/([^:]\/)\/+/g, "$1")}
            // sx={{ width: 100, height: 100 }}
            variant="rounded"
          />
        </div>
      ),
    },
  ];
  const { t: translate } = useTranslation(["testimonials"]);
  return (
    <Layout title={"Testimonial"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Typography variant="h6">
            {translate("All Born To Win Testimonial")}
          </Typography>

          <Link to="/add-testimonials" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              sx={{ borderRadius: "5px" }}
            >
              {translate("Add")}
            </Button>
          </Link>
        </Box>
        {testimonials?.testimonials ? (
          <Table
            data={testimonials?.testimonials}
            fields={testimonialsColumns}
            numberOfRows={testimonials?.testimonials?.length}
            enableTopToolBar={true}
            enableBottomToolBar={true}
            enablePagination={true}
            enableRowSelection={true}
            enableColumnFilters={true}
            enableEditing={true}
            enableColumnDragging={true}
            showPreview={true}
            deleteFunction={handleRemoveTestimonial}
            upDatefunction={handleUpdateTestimonial}
          />
        ) : (
          <Loading />
        )}
      </Box>
      <ToastContainer />
    </Layout>
  );
};

export default ViewTestimonial;
